module.exports = __webpack_public_path__ + "assets/img/Ulu Pandan Park Connector.bcd609c1.jpg";